/**
 *
 */
const state = {
	isShow: JSON.parse(window.sessionStorage.getItem('isShow') || false)
}
const getters = {}
const mutations = {
	IS_SHOW(state, isShow) {
		if (state.isShow === null) {
			window.sessionStorage.setItem('isShow', isShow)
			state.isShow = false
			console.log(state.isShow,isShow,'state.isShow')
		}
	}
}
const actions = {}

export default {
	state,
	getters,
	mutations,
	actions,
	namespaced: true
}
